












import { Component, Prop, Vue } from "vue-property-decorator";
import { InfoConfigProblem } from "@/data/models/InfoConfigAdministration";

/** A Beschreibung's problems, each with its line where it has one: errors red, warnings orange. */
@Component
export default class InfoConfigProblemListComponent extends Vue {
  @Prop({ required: true })
  problems!: InfoConfigProblem[];
}
